import httpClient from "./http-client";

const ENDPOINT = "/auth";

export interface AuthCredentialsDto {
  username: string;
  password: string;
}

export interface AuthSuccessDto {
  accessToken: string;
  refreshToken: string;
  username: string;
  role: string;
  roleDisplay: string;
  carrerasVisitanteIDs?: number[];
  persona?: any;
}

export interface PersonaCreateDto {
  correo: string;

  //datos de la persona
  tipoIdentificacion: string;

  identificacion: string;

  nombre: string;

  apellido: string;

  sexo: string;

  telefono: string;

  fechaNacimiento: string;

  //dispacidad: boolean;
  carnetConadis?: string;

  password?: string;

  // Address information
  country: string;
  province: string;
  canton: string;
}

class AuthService {
  //post
  login(authCredentialsDto: AuthCredentialsDto) {
    return httpClient
      .post(ENDPOINT + "/signin", authCredentialsDto)
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("jwt_token_kr", response.data.accessToken);
          localStorage.setItem("jwt_refresh_kr", response.data.refreshToken);
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("jwt_token_kr");
    localStorage.removeItem("jwt_refresh_kr");
    localStorage.removeItem("user");
  }

  signup(personaCreateDto: PersonaCreateDto) {
    return httpClient.post(ENDPOINT + "/signup", personaCreateDto);
  }

  resetPassword(dto: { username: string }) {
    return httpClient.post(`${ENDPOINT}/reset-password`, dto);
  }

  updatePassword(dto: { password: string , token: string}) {
    const route = !dto.token ? 'update' : 'update-password';
    return httpClient.put(`${ENDPOINT}/${route}`, dto);
  }

  verifyToken(dto: { token: string }) {
    const route = 'verify-account';
    return httpClient.put(`${ENDPOINT}/${route}`, dto);
  }
}
export default new AuthService();
